<div class="forgot-password-wrapper">
    <div class="forgot-password">
        <img src="assets/images/ncvib.svg" alt="NCVIB" height="60" width="auto" style="margin-bottom: 20px;"/>
        <div *ngIf="!passwordChanged">
            <h4>{{ 'ForgotYourPassword' | translate }}?</h4>
            <p *ngIf="!userNameIsUnknown">{{ 'PleaseEnterYourUsernameAndWellSendAResetLink' | translate }}</p>
            <p *ngIf="userNameIsUnknown">{{ 'PleaseEnterYourEmailAndWellSendAResetLink' | translate }}</p>

            <form #form="ngForm" class="form-inline email-form">
                <input type="text"
                       class="form-control"
                       [(ngModel)]="userName"
                       *ngIf="!userNameIsUnknown"
                       required
                       id="inputUsername"
                       name="inputUsername"
                       placeholder="{{ 'Username' | translate }}"/>
                <input type="text"
                       class="form-control"
                       [(ngModel)]="email"
                       *ngIf="userNameIsUnknown"
                       required
                       id="inputEmail"
                       name="inputEmail"
                       placeholder="{{ 'Email' | translate }}"/>
                <div class="custom-control custom-switch mt-1" *ngIf="!passwordChanged">
                    <input class="custom-control-input ml-2" type="checkbox" id="inputType" name="InputType" [(ngModel)]="userNameIsUnknown">
                    <label class="custom-control-label" for="inputType">{{ userNameIsUnknownLabel() | translate }}</label>
                </div>
                <button type="submit" value="submit" class="btn btn-primary" (click)="sendEmail()">
                    <i class="fas fa-paper-plane mr-2"></i>
                    {{ 'Send' | translate }}
                </button>
            </form>
            <label style="color: red;">{{ errorMessage }}</label>
        </div>
        <div *ngIf="passwordChanged">
            <label>{{ 'EmailHasBeenSent' | translate }}. {{ 'Click' | translate }} <a routerLink="/login"> {{ 'here' | translate }} </a> {{ 'toReturnToTheLoginPage' | translate }}.</label>
        </div>
    </div>
</div>
